import * as z from "zod";

export const getOrdersMetrics = {
  name: "getOrdersMetrics" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    totalOrders: z.number(),
    averageOrderValue: z.number(),
    totalSales: z.number(),
    refunds: z.number(),
  }),
};
